import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=322a2824&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('322a2824')) {
      api.createRecord('322a2824', component.options)
    } else {
      api.reload('322a2824', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=322a2824&", function () {
      api.rerender('322a2824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/projects/Create.vue"
export default component.exports